<div [kalLoading]="loading">

    <div kalDialogContent>

        <app-shared-beneficiary-list isModalContext
                                     [hiddenBeneficiaryIdList]="data.hiddenBeneficiaryIdList"
                                     [selection]="data.selection">
        </app-shared-beneficiary-list>
    </div>

    @if(!beneficiaryListComponent?.beneficiaryFiltersComponent?.displayFilters) {

        <div kalDialogFooter>

            <div class="gup-C-validationArea gup-O-list">

                <div class="gup-O-list__item">

                    <kal-button (click)="submit()"
                                [disabled]="!beneficiaryListComponent?.hasSelection"
                                kalTheme="primary">
                        Ajouter
                    </kal-button>

                </div>

                <div class="gup-O-list__item">

                    <kal-button (click)="close()"
                                kalTheme="secondary">
                        Annuler
                    </kal-button>

                </div>

            </div>

        </div>

    }
</div>
